Ext.namespace('utils.form.event');

utils.form.event = (function( $, Ext, window, undefined ){
    var public = new Object(), scope = null;
	
    public.setScope = function(_scope){
		scope = _scope;
    };
	
	public.init = function(){
		var funs = scope.utils.form.event();

		Ext.get('form').on("submit", function(){
			Ext.getCmp('button-save').handler.call(Ext.getCmp('button-save').scope);
		});
		
		$(document).on('click', '.dec-medias .button a', funs.onDeleteFile);
				
		$('[wp-event="checkbox-display"]').on('change', $.proxy(this.onCheckboxDisplay, this));
		$('[wp-event="select-display"]').on('change', $.proxy(this.onSelectDisplay, this));

		$('[wp-event="select-display"], [wp-event="checkbox-display"]').each(function(index, element) {
			$(this).trigger('change');
		});
	};
	
	public.onSelectDisplay = function(e)
	{
		var element = $(e.currentTarget);
		var prefix = element.data('prefix');
		var name = (typeof prefix !== "undefined" ? prefix : '') + 
				   (typeof element.data('name') !== "undefined" ? element.data('name') : element.attr('name'));
		
		$($.php.sprintf('.%s', name)).hide();
		
		if(element.is(':checked') || element.is('select'))
		{
			$($.php.sprintf('.%s.%s', name, element.val())).show();
		}
	};
	
	public.onCheckboxDisplay = function(e)
	{
		var element = $(e.currentTarget);
		var prefix = element.data('prefix');
		var name = (typeof prefix !== "undefined" ? prefix : '') + 
				   (typeof element.data('name') !== "undefined" ? element.data('name') : element.attr('name'));

		$($.php.sprintf('.%s', name)).hide();

		var checked = $($.php.sprintf('input[name="%s"]:checked', name));

		if(checked.get(0))
		{
			$($.php.sprintf('.%s.%s', name, checked.val())).show();
		}
	};

	public.onSave = function(){
		var params = {}, isVaild = false;
		
		for ( instance in CKEDITOR.instances )
		{
			params['_'+instance] = CKEDITOR.instances[instance].getData()
		}

		if (scope.window.form.isValid()) isVaild = true;

		if($('input[name="ext-type-phone"]').get(0))
		{
			$('input[name="phone"]').val($('input[name="ext-type-phone"]').intlTelInput("getNumber"));

			if(!$('input[name="ext-type-phone"]').intlTelInput("isValidNumber"))
			{
				isVaild = false;

				alert('電話格式錯誤.');
			}
		}

		if (isVaild)
		{
			Ext.getCmp("button-save").setDisabled(true);
			
			scope.window.form.submit({
				waitTitle: '系統提示',
				waitMsg: '資料處理中..',
				url: app.config.url.save,
				method: 'POST',
				params : params,
				success: function(form, action){
					var result = action.result;
					var _close = app.config.closepage;
					var _fun = scope.utils.form.event().onSaveComplete;
					
					Ext.getCmp("button-save").setDisabled(false);
					
					if (result.success)
					{
						top.toastr.success(result.message);
						
						if(typeof _fun === 'function')
						{
							_fun(result);
						}
						else if(_close)
						{
							top.units.recCmpPage(_close.code, _close.back);
						}
						else
						{
							try{
								scope.lightBox.form.hide();
								scope.window.view.getGridStore().reload();
							}catch(e){
								location.reload();
							}
						}
					}
					else top.toastr.error(result.message);
				},
				failure : function(form, action){
					Ext.getCmp("button-save").setDisabled(false);
					
					if(action.result) 
					{
						Ext.MessageBox.alert('提示', action.result.message);
					}
				}
			});
		}
	};
	
	public.onReset = function(){
		if(scope.utils.grid)
		{
			var id = scope.window.form.findField("rowId").getValue();
			var funs = scope.utils.grid.event();
	
			id != '' ? funs.onEdit(id) : scope.window.form.reset(); 
		}
		else 
			scope.window.form.reset(); 
	};
	
	public.onDeleteFile = function(){
		var rowId = $(this).attr('data-id');
		var el = $(this).closest(".dec-medias");
		
		Ext.MessageBox.confirm('系統提示', '是否刪除檔案?', function(type){
			if(type == 'yes')
			{
				Ext.Ajax.request({
					url: app.config.url.unfile,
					params: {'rowId' : rowId},   
					method: 'POST',
					success: function (v,c) {
						var result = Ext.decode(v.responseText);
						
						if (result.success)
						{
							top.toastr.success(result.message);
							
							el.remove();
						}
						else top.toastr.error(result.message);
					}
				});
			}
		});
	};
    
    return public;
}( jQuery, Ext, window ));


